function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M175.377 497.59h208.246"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232.501 314.533c-47.05 42.927-77.835 85.79-68.76 95.736 9.074 9.946 54.572-16.79 101.622-59.717l-32.862-36.019",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232.501 314.533c-47.05 42.927-77.835 85.79-68.76 95.736 9.074 9.946 54.572-16.79 101.622-59.717l-32.862-36.019",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M258.412 485.299h.287v10.919h-.287z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M258.412 485.299h.287v10.919h-.287z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.951 497.59c0-14.733 17.017-26.676 38.009-26.676s38.009 11.943 38.009 26.676H220.95",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.951 497.59c0-14.733 17.017-26.676 38.009-26.676s38.009 11.943 38.009 26.676H220.95",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.008 508c-6.459-13.242 3.6-31.436 22.468-40.638 18.867-9.202 39.398-5.928 45.856 7.314L270.008 508",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.008 508c-6.459-13.242 3.6-31.436 22.468-40.638 18.867-9.202 39.398-5.928 45.856 7.314L270.008 508",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 261.555,
  cy: 391.096,
  rx: 73.373,
  ry: 94.424,
  fill: "#000"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 261.555,
  cy: 391.096,
  rx: 73.373,
  ry: 94.424,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 293.027,
  cy: 389.051,
  rx: 38.009,
  ry: 69.482,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 293.027,
  cy: 389.051,
  rx: 38.009,
  ry: 69.482,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.501 263.288c21.967 9.904 25.32 31.071 7.489 47.279-17.832 16.207-50.094 21.317-72.061 11.413-21.967-9.904-25.32-31.071-7.489-47.279 17.832-16.207 50.094-21.317 72.061-11.413",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.501 263.288c21.967 9.904 25.32 31.071 7.489 47.279-17.832 16.207-50.094 21.317-72.061 11.413-21.967-9.904-25.32-31.071-7.489-47.279 17.832-16.207 50.094-21.317 72.061-11.413",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.702 281.379c2.54 1.756 3.08 5.17 1.208 7.626-1.873 2.455-5.45 3.021-7.99 1.265-2.539-1.756-3.08-5.17-1.207-7.626 1.873-2.455 5.45-3.021 7.989-1.265",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.702 281.379c2.54 1.756 3.08 5.17 1.208 7.626-1.873 2.455-5.45 3.021-7.99 1.265-2.539-1.756-3.08-5.17-1.207-7.626 1.873-2.455 5.45-3.021 7.989-1.265",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M288.822 264.486c19.032-1.728 34.15-6.562 33.765-10.797-.384-4.235-16.125-6.266-35.158-4.538l1.393 15.335",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M288.822 264.486c19.032-1.728 34.15-6.562 33.765-10.797-.384-4.235-16.125-6.266-35.158-4.538l1.393 15.335",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.755 275.722c-20.456 4.605-37.795 4.977-38.728.832-.933-4.145 14.894-11.237 35.35-15.841l3.378 15.01",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.755 275.722c-20.456 4.605-37.795 4.977-38.728.832-.933-4.145 14.894-11.237 35.35-15.841l3.378 15.01",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.214 275.671c-4.7-31.098 9.807-59.076 32.4-62.49 22.594-3.415 44.72 19.027 49.42 50.125l-81.82 12.365",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.214 275.671c-4.7-31.098 9.807-59.076 32.4-62.49 22.594-3.415 44.72 19.027 49.42 50.125l-81.82 12.365",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M230.1 272.622c-4.593-30.398 2.843-56.726 16.61-58.807 13.767-2.08 28.651 20.875 33.245 51.272l-49.854 7.535",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.1 272.622c-4.593-30.398 2.843-56.726 16.61-58.807 13.767-2.08 28.651 20.875 33.245 51.272l-49.854 7.535",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 244.194,
  cy: 210.171,
  r: 8.171,
  fill: "#797979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 244.194,
  cy: 210.171,
  r: 8.171,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M357.371 356.635l9.593 6.23-5.947 9.157-9.593-6.23z",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.371 356.635l9.593 6.23-5.947 9.157-9.593-6.23z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 378.91,
  cy: 335.604,
  r: 29.005,
  fill: "#797979"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 378.91,
  cy: 335.604,
  r: 29.005,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M350.525 363.977l13.02 8.455-27.964 43.062-13.02-8.455z",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.525 363.977l13.02 8.455-27.964 43.062-13.02-8.455z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 378.323,
  cy: 335.604,
  r: 18,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 378.323,
  cy: 335.604,
  r: 18,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M215.321 372.3c77.678 24.676 143.953 34.278 148.03 21.446 4.076-12.832-55.59-43.239-133.268-67.915L215.321 372.3",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.321 372.3c77.678 24.676 143.953 34.278 148.03 21.446 4.076-12.832-55.59-43.239-133.268-67.915L215.321 372.3",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M141.817 254.448c.741 17.168 33.17-.915 33.17-.915s-33.912-16.252-33.17.915z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.817 254.448c.741 17.168 33.17-.915 33.17-.915s-33.912-16.252-33.17.915z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M176.878 204.9c-14.165 9.726 18.354 27.644 18.354 27.644s-4.188-37.37-18.354-27.645z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.878 204.9c-14.165 9.726 18.354 27.644 18.354 27.644s-4.188-37.37-18.354-27.645z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M316.116 284.628c18.497 5.899 20.708 19.862 4.94 31.187-15.77 11.326-43.547 15.725-62.044 9.827-18.497-5.899-20.708-19.861-4.94-31.187 15.77-11.325 43.547-15.725 62.044-9.827",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.116 284.628c18.497 5.899 20.708 19.862 4.94 31.187-15.77 11.326-43.547 15.725-62.044 9.827-18.497-5.899-20.708-19.861-4.94-31.187 15.77-11.325 43.547-15.725 62.044-9.827",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M245.864 312.41l83.602-13.24"
}))));

var SvgSherlock = function SvgSherlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "138.305 198.5 273.117 313"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/sherlock.672128f4.svg";
export { SvgSherlock as ReactComponent };